/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {OnCareConfigQueryReturned} from "@modules/GoalsConfigModule";
import * as React from "react";
import {Loader} from "../../widgets/Loader";
import {margin_b_lg, padding_rl_sm, Spacing} from "@styles/styles";
import {ConfigGeneralWrapper} from "./_to_be_modified/ConfigGeneralWrapper";
import {wellnessCoachFieldDefsArrayForOrganization} from "@app/app-shared/care_config";
import {PatientProvider} from "./PatientProvider";
import {DB_Patient} from "@app/app-shared/patient";
import {OrganizationsContext} from "./ui/organizations/OrganizationsContext";

type State = {
    loadedPatient: boolean
}

export const Page_WellnessCoach = () => <PatientProvider>{p => <WellnessCoach patient={p}/>}</PatientProvider>

type Props = {
    patient: DB_Patient
};

class WellnessCoach
    extends BaseComponent<Props, State>
    implements OnCareConfigQueryReturned {

    __onCareConfigQueryReturned() {
        this.forceUpdate();
    }

    render() {
        const patient = this.props.patient;

        if (!patient)
            return <Loader/>;

        return <OrganizationsContext.Consumer>
            {({organizations}) => {
             return <div className={`ll_h_s ${margin_b_lg}`} style={{marginLeft: -Spacing.s, marginRight: -Spacing.s}}>

                {/* Left Column */}
                <div className={`ll_v_s ${padding_rl_sm}`} style={{flex: 1}}>
                    <div className={`ll_v_s`}>
                        <ConfigGeneralWrapper
                            patient={patient}
                            fieldDefs={wellnessCoachFieldDefsArrayForOrganization(organizations[patient.organizationId])}
                            title={"Goals"}
                            showActions={false}
                        />
                    </div>
                </div>

                {/* Right Column (empty) */}
                <div className={`ll_v_s ${padding_rl_sm}`} style={{flex: 1}}/>
            </div>}}
        </OrganizationsContext.Consumer>;
    }
}
